import { Helmet } from "react-helmet-async";
import GenieEmbed from "@/components/widget/GenieEmbed";
import { getCanonicalUrl } from "@/config/site";
import { createOrganizationSchema, createWebSiteSchema } from "@/config/seo";
import HomeFooter from "../HomeFooter";
import ConsumerCTA from "./ConsumerCTA";
import ConsumerGenieCTA from "./ConsumerGenieCTA";
import ConsumerHero from "./ConsumerHero";
import ConsumerNav from "./ConsumerNav";

export default function ConsumerHomePage() {
  const description =
    "Help Genie for consumers gives people a personal AI assistant for quick answers, daily help and convenient voice experiences.";
  const organizationSchema = createOrganizationSchema();
  const websiteSchema = createWebSiteSchema();

  return (
    <>
      <Helmet>
        <title>Help Genie for Consumers | Personal AI Help on Demand</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={getCanonicalUrl("/consumer")} />
        <meta property="og:title" content="Help Genie for Consumers | Personal AI Help on Demand" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={getCanonicalUrl("/consumer")} />
        <meta property="og:image" content={getCanonicalUrl("/helpgenie_logo.png")} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Help Genie for Consumers | Personal AI Help on Demand" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={getCanonicalUrl("/helpgenie_logo.png")} />
        <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>

      <div className="min-h-screen">
        <ConsumerNav />
        <ConsumerHero />
        <ConsumerGenieCTA />
        <ConsumerCTA />
        <HomeFooter />
        <GenieEmbed position="bottom-right" />
      </div>
    </>
  );
}
